import React from "react";
import {StyledBlockContent} from "./Block";

function BlockTable(props) {
  const { as, fullHeight, style, ...filteredProps} = props

  const className = `block ${fullHeight ? 'fullHeight' : ''}`

  if (as) {
    return React.createElement(as, {className, style}, <BlockContent {...filteredProps} />)
  } else {
    return React.createElement('div', {className, style}, <BlockContent {...filteredProps} />)
  }
}

function BlockContent(props) {

  return (
    <StyledBlockContent className="block-content" style={{padding: "0px", border: "none"}}>
      {props.children}
    </StyledBlockContent>
  )
}

export default BlockTable
